import { Component, OnInit } from '@angular/core';
import { Firestore, collectionGroup, collectionData } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Pig } from '../../interfaces/pig.interface';
import { PaymentService } from '../../services/payment.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-payment-center',
  templateUrl: './payment-center.component.html',
  styleUrls: ['./payment-center.component.css'],
  imports: [CommonModule]
})
export class PaymentCenterComponent implements OnInit {
  orders$: Observable<any[]> | undefined;
  selectedPig: Pig | null = null;
  isProcessingPayment = false;
  
  constructor(
    private firestore: Firestore,
    public docModal: NgbModal,
    private paymentService: PaymentService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    // Lấy tất cả các đơn hàng từ mọi user (collectionGroup)
    const receivedItemsGroup = collectionGroup(this.firestore, 'receivedItems');
    this.orders$ = collectionData(receivedItemsGroup, { idField: 'id' });
  }

  viewDetail(order: Pig): void {
    this.selectedPig = order;
  }

  /**
   * Xử lý thanh toán VNPay
   */
  async processVNPayPayment(): Promise<void> {
    if (!this.selectedPig || this.isProcessingPayment) return;

    this.isProcessingPayment = true;
    this.toastr.info('Đang tạo yêu cầu thanh toán...', 'Thông báo');

    try {
      const result = await this.paymentService.createVNPayPayment(this.selectedPig);
      
      if (result.success && result.paymentUrl) {
        this.toastr.success('Chuyển hướng đến trang thanh toán VNPay', 'Thành công');
        // Chuyển hướng đến trang thanh toán VNPay
        window.location.href = result.paymentUrl;
      } else {
        this.toastr.error(result.message || 'Không thể tạo yêu cầu thanh toán', 'Lỗi');
      }
    } catch (error) {
      console.error('VNPay payment error:', error);
      this.toastr.error('Có lỗi xảy ra khi xử lý thanh toán', 'Lỗi');
    } finally {
      this.isProcessingPayment = false;
    }
  }

  /**
   * Xử lý thanh toán MoMo
   */
  async processMoMoPayment(): Promise<void> {
    if (!this.selectedPig || this.isProcessingPayment) return;

    this.isProcessingPayment = true;
    this.toastr.info('Đang tạo yêu cầu thanh toán MoMo...', 'Thông báo');

    try {
      const result = await this.paymentService.createMoMoPayment(this.selectedPig);
      
      if (result.success && result.paymentUrl) {
        this.toastr.success('Chuyển hướng đến trang thanh toán MoMo', 'Thành công');
        window.location.href = result.paymentUrl;
      } else {
        this.toastr.error(result.message || 'Không thể tạo yêu cầu thanh toán MoMo', 'Lỗi');
      }
    } catch (error) {
      console.error('MoMo payment error:', error);
      this.toastr.error('Có lỗi xảy ra khi xử lý thanh toán MoMo', 'Lỗi');
    } finally {
      this.isProcessingPayment = false;
    }
  }

  /**
   * Hiển thị modal chọn phương thức thanh toán
   */
  showPaymentOptions(): void {
    if (!this.selectedPig) return;

    const confirmPayment = window.confirm(
      `Bạn có muốn thanh toán đơn hàng ${this.selectedPig.pigNumber} với số tiền ${this.selectedPig.purchasedPrice.toLocaleString()} đ?`
    );

    if (confirmPayment) {
      // Hiển thị các tùy chọn thanh toán
      const paymentMethod = window.prompt(
        'Chọn phương thức thanh toán:\n1. VNPay\n2. MoMo\n\nNhập số (1 hoặc 2):'
      );

      if (paymentMethod === '1') {
        this.processVNPayPayment();
      } else if (paymentMethod === '2') {
        this.processMoMoPayment();
      } else if (paymentMethod !== null) {
        this.toastr.warning('Vui lòng chọn phương thức thanh toán hợp lệ', 'Thông báo');
      }
    }
  }
}
